import * as Yup from 'yup';
import { REQUIRED } from '../constants/error';

export const CodeSchema = Yup.object().shape({
  verificationCode: Yup.string().required(REQUIRED),
});
